import './Card.scss';

import Card from 'react-bootstrap/Card';

function CustomCard({
  children,
  backgroundColor,
  minHeight,
  onClick,
  className = '',
  ...props
}) {
  return (
    <Card
      className={`hallapp-card ${className}`}
      body
      onClick={onClick}
      style={{ backgroundColor, minHeight, cursor: onClick ? 'pointer' : 'default' }}
      {...props}
    >
      {children}
    </Card>
  );
}

export default CustomCard;